import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';

const ComingSoon = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { Translate, setMarker } = useContext(ProductContext);
    const ComingSoon = location.state;
    const examTypes = ComingSoon?.examTypes || [];
    const [activePage, setActivePage] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    // Find N5 exam_id
    const n5Exam = examTypes.find(exam => exam.exam_type.toLowerCase() === 'n5');
    const n5ExamId = n5Exam ? n5Exam.exam_id : (examTypes[0]?.exam_id || null);

    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);

    const handleBackClick = () => {
        navigate('/', {
            state: {
                examTypes,
                selectedExamId: n5ExamId,
                selectedExamType: n5Exam ? n5Exam.exam_type : examTypes[0]?.exam_type,
            }
        });
    };

    const handleReturnToHome = () => {
        // Reset data
        localStorage.removeItem("selectedExamId");
        localStorage.removeItem("LearningDataLocal");
        localStorage.removeItem("couponVerified");
        setMarker([]); // Reset marker in context
        navigate('/');
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={handleBackClick} className='icon_1' />
                            <h2></h2> {/* Display the selected day */}
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="coming-soon-container">
                <div className="coming-soon-content">
                    <div className="coming-soon-text">
                        <h4>
                            {Translate?.message?.data?.uhohPleaseVisitLater || "Uh oh! Please Visit Later"}
                        </h4>
                        <h5>{Translate?.message?.data?.comingSoon || "Coming Soon!"}</h5>
                        <button onClick={handleReturnToHome} className="JHS-action-button">
                            {Translate?.message?.data?.returnBackToHome || "Return Back to Home"}
                        </button>
                    </div>
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/read.jpg`}
                        alt="No Questions Found"
                        className="coming-soon-image"
                    />
                </div>
            </div>
      <Footer />
    </div>
  );
};

export default ComingSoon;